import React, { useEffect, useState } from "react";
import { Header } from "../../components/molecules";
import { AnalyticsService, notificationSchedulerTime, apiPostWithStatusCode } from '../../utils';
import { Count, Title } from "../../components/atoms";
import { routes } from "../../router/paths";
import { Link } from "react-router-dom";
import { ALLOWREFUND, DECLINEREFUND, GETNEWORDERS } from '../../api/apiConfig';
import { useLocation, useNavigate } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { Howl } from 'howler';
import actions from "../../store/actions";
import notificationSound from '../../assets/sounds/elegant-notification-sound.mp3'

const NotificationScreen = () => {
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState("Processing");
  const [info2, setInfo2] = useState("");
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const id = getQueryVariable('id')
  const name = getQueryVariable('vendor')
  const type = getQueryVariable('type')
  const lineItemId = getQueryVariable('lineitemid')

  console.log(location)

  useEffect(() => {
    if(id === undefined || id === null || id === "" || lineItemId === null || lineItemId === undefined || lineItemId === ""){
      navigate('/dashboard');
    }else{
      const token = localStorage.getItem("access_token");
      var order= { OrderId:id,Status:name, LineItemId:lineItemId }
      if(type==1){
        fetch(ALLOWREFUND, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(order),
        })
          .then((response) => {
            if (response.status === 200) {
              toast.success("Refund Allowed successfully");
              setInfo("Refund Allowed successfully")
              setInfo2("Tap anywhere to close")
            } else {
              toast.error("Something went wrong!");
              setInfo("Something went wrong!")
            }
          })
          .catch((e) => {
            toast.error("Something went wrong!");
            setInfo("Something went wrong!")
          });
        }else{
          fetch(DECLINEREFUND, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(order),
          })
            .then((response) => {
              if (response.status === 200) {
                toast.success("Refund Declined successfully");
                setInfo("Refund Declined successfully")
                setInfo2("Tap anywhere to close")
              } else {
                toast.error("Something went wrong!");
                setInfo("Something went wrong!")
              }
            })
            .catch((e) => {
              toast.error("Something went wrong!");
              setInfo("Something went wrong!")
            });
        }
    }
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function(e){
      this.window.history.pushState(null, this.document.title, this.window.location.href);
    });
  }, []);

  function getQueryVariable(variable)
  {
          var query = window.location.search.substring(1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
                      var pair = vars[i].split("=");
          if(pair[0] == variable){return pair[1];}
          }
          return(false);
  }

  return (
    <Link to={routes.dashboard} className="textDec">
      <div className="notificationsSec">
        <Header leftItem={"The Cricket Store"} rightItem={"Merchant's Tablet"} />
        <div style={styles.centralDiv}>
          <div className={"centerAlign"}>
            {/* <Count countNo={orderCount} isLoading={loading} /> */}
          </div>
          <Title text={info} className="customTitle" />
          <Title
            text={info2}
            className="customSubTitle"
          />
        </div>
      </div>
    </Link>
  );
};
export default NotificationScreen;
const styles = {
  centralDiv: {
    display: "flex",
    flexDirection: "column",
    height: "74%",
    justifyContent: "center",
  },
};
